import http from '../api/httpRequest.js'
import { RTC_STATE } from "../api/enums.js"
export default {

	state: {
		isLoggedIn: false,
		userInfo: {
			id: -1,
			username: '',
			nickName: '',
			avatar: '',
			terminal: null  // 新增：当前登录终端 (0:傻蛋网页端, 1:傻蛋精灵App, 2:我的电脑, 3:我的云电脑, 4:傻蛋浏览器, 5:MCP, 6:我的小龙虾)
		},
		rtcInfo: {
			friend: {},  // 好友信息
			mode: "video", // 模式 video:视频 voice:语音
			state: RTC_STATE.FREE // FREE:空闲  WAIT_CALL:呼叫方等待 WAIT_ACCEPT: 被呼叫方等待接听  CHATING:聊天中 
		}
	},
	
	getters: {
		// 获取当前用户终端
		currentTerminal: (state) => {
			return state.userInfo.terminal;
		},
		
		// 获取终端名称
		terminalName: (state) => {
			const terminalMap = {
				0: '傻蛋网页端',
				1: '傻蛋精灵App',
				2: '我的电脑',
				3: '我的云电脑',
				4: '傻蛋浏览器',
				5: 'MCP',
				6: '我的小龙虾'
			};
			return terminalMap[state.userInfo.terminal] || '未知终端';
		}
	},

	mutations: {
		setIsLoggedIn(state, isLoggedIn) {
			console.log('[Store] setIsLoggedIn:', isLoggedIn);
			state.isLoggedIn = isLoggedIn;
		},
		setUserInfo(state, userInfo) {
			console.log('[Store] setUserInfo:', userInfo);
			state.userInfo = userInfo
		},
		updateUserInfo(state, userInfo) {
			// 合并更新用户信息，保留现有字段
			state.userInfo = { ...state.userInfo, ...userInfo };
		},
		setTerminal(state, terminal) {
			console.log('[Store] setTerminal:', terminal);
			state.userInfo.terminal = terminal;
			// 持久化存储
			if (typeof terminal === 'number') {
				localStorage.setItem('userTerminal', terminal.toString());
			}
		},
		setRtcInfo(state, rtcInfo) {
			state.rtcInfo = rtcInfo;
		},
		setRtcState(state, rtcState) {
			state.rtcInfo.state = rtcState;
		},
		clear(state) {
			state.isLoggedIn = false;
			state.userInfo = {};
			state.rtcInfo = {
				friend: {},
				mode: "video",
				state: RTC_STATE.FREE
			};
		}
	},
	actions: {
		loadUser(context) {
			return new Promise((resolve, reject) => {
				http({
					url: '/user/self',
					method: 'GET'
				}).then((userInfo) => {
					// 从 sessionStorage 获取 tokenKey，并合并到 userInfo
					const sessionTokenKey = sessionStorage.getItem('tokenKey');
					if (sessionTokenKey) {
						userInfo.tokenKey = sessionTokenKey;
						console.log('[UserStore] 从 sessionStorage 获取 tokenKey');
					}

					context.commit("setUserInfo", userInfo);
					// 🔥 加载用户信息成功后，设置登录状态为 true
					context.commit("setIsLoggedIn", true);

					// 尝试从 localStorage 恢复 terminal
					const savedTerminal = localStorage.getItem('userTerminal');
					if (savedTerminal !== null) {
						context.commit('setTerminal', parseInt(savedTerminal));
					}

					// 解析 happyAuthCredentials 并保存 happyToken
					if (userInfo.happyAuthCredentials) {
						try {
							const credentials = JSON.parse(userInfo.happyAuthCredentials);
							if (credentials.token) {
								sessionStorage.setItem('happyToken', credentials.token);
								console.log('[UserStore] ✅ 已保存 happyToken');
							}
						} catch (e) {
							console.error('[UserStore] ❌ 解析 happyAuthCredentials 失败:', e);
						}
					}

					resolve();
				}).catch((res) => {
					// 🔥 加载失败时，清除登录状态
					context.commit("setIsLoggedIn", false);
					reject(res);
				});
			})
		},
		
		// 初始化终端信息（从环境推断）
		initTerminal(context) {
			// 如果已经有终端信息，不重复初始化
			if (context.state.userInfo.terminal !== null) {
				return;
			}
			
			// 尝试从 localStorage 恢复
			const savedTerminal = localStorage.getItem('userTerminal');
			if (savedTerminal !== null) {
				context.commit('setTerminal', parseInt(savedTerminal));
				return;
			}
			
			// 根据环境推断默认终端
			let terminal = 0; // 默认：傻蛋网页端
			
			if (window.vscodeServices) {
				terminal = 2; // VS Code 环境：我的电脑
			} else if (window.electronAPI) {
				terminal = 2; // Electron 环境：我的电脑
			} else if (navigator.userAgent.includes('Mobile')) {
				terminal = 1; // 移动设备：傻蛋精灵App
			}
			
			console.log('[UserStore] 推断终端类型:', terminal);
			context.commit('setTerminal', terminal);
		},
		setIsLoggedIn(context, isLoggedIn) {
			console.log('[UserStore Action] setIsLoggedIn:', isLoggedIn);
			context.commit('setIsLoggedIn', isLoggedIn);
		}
	}
}